import React from 'react';
import { useLocation } from 'react-router-dom';
import styles from './index.module.scss';

const SHOULD_SHOW_PATHS = ['/bookshelf', '/bookstore'];
const SUPPORT_URL = 'https://book-support.nani.com.tw/hc/zh-tw';

const FloatingServiceButton = () => {
  const { pathname } = useLocation();
  const shouldShow = SHOULD_SHOW_PATHS.includes(pathname);

  if (!shouldShow) return null;

  return (
    <button
      className={styles.floatingButton}
      onClick={() => window.open(SUPPORT_URL, '_blank', 'noopener,noreferrer')}
      aria-label="支援中心"
    >
      <img src="/img/serviceBtn.svg" alt="支援中心" />
    </button>
  );
};

export default FloatingServiceButton;
